$(window).load(function () {
    if (document.getElementById('copyright_year')) {
        document.getElementById('copyright_year').textContent = new Date().getFullYear();
    }
});